export enum StarType {
	Full,
	Half,
	Empty
  }
  